<template>
  <div class="soar-container flex flex-col gap-y-4">
    <h1 class="text-xl md:text-2xl text-primary font-medium border-b border-brand-gray-300">
      {{ $t('yourAccount') }}
    </h1>
    <div class="w-full h-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <component
        :key="key"
        :is="m.as"
        :to="m.to"
        :class="{ 'hover:scale-105': m.as == 'RouterLink' }"
        v-for="(m, key) in menu"
        class="w-full max-h-max py-6 flex flex-col gap-y-4 justify-start items-center aspect-auto border border-primary rounded-lg p-4 shadow-sm"
      >
        <div class="flex justify-center items-center rounded-full size-20 bg-brand-gray-250">
          <i :class="[m.icon]" class="text-[2rem] text-primary"></i>
        </div>
        <div class="flex flex-col items-center gap-y-2">
          <h1 class="text-xl text-primary/80">{{ $t(m.title) }}</h1>
          <small class="ltr:font-sans text-xs text-center text-brand-black-secondary">
            {{ $t(m.subtitle) }}
          </small>
        </div>
        <div class="flex flex-col gap-y-3">
          <RouterLink
            :to="c.to"
            :key="key"
            v-for="(c, key) in m.children"
            class="text-center text-primary hover:scale-105"
          >
            {{ $t(c.title) }}
          </RouterLink>
        </div>
      </component>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const menu = [
  {
    icon: 'ica-custom-fonts-printing-services',
    title: 'userProfileInformationSettings',
    subtitle: 'userProfileInformationSettingsDesc',
    as: 'div',
    to: null,
    children: [
      {
        title: 'userProfileInformationSettings',
        to: { name: 'AuthUserProfile' }
      },
      {
        title: 'userNotificationSettings',
        to: { name: 'AuthUserNotificationSettings' }
      }
    ]
  },
  {
    icon: 'ica-custom-fonts-password',
    title: 'securityLogin',
    subtitle: 'securityLoginDesc',
    as: 'div',
    to: null,
    children: [
      // {
      //   title: 'changeUserName',
      //   to: { name: 'AuthUserChangeUsername' }
      // },
      {
        title: 'changePassword',
        to: { name: 'AuthUserChangePassword' }
      },
      {
        title: 'twoStepVerificationAndLoggedInHistory',
        to: { name: 'AuthUserTwoStep' }
      }
    ]
  },
  {
    icon: 'ica-custom-fonts-home',
    title: 'addressInfo',
    subtitle: 'addressesDesc',
    as: 'RouterLink',
    to: { name: 'AuthUserAddresses' }
  },
  {
    icon: 'ica-custom-fonts-selected-star',
    title: 'userPreferences',
    subtitle: 'userPreferencesDesc',
    as: 'RouterLink',
    to: { name: 'AuthUserPreferences' }
  }
]
</script>

<style lang="scss" scoped></style>
